/* Momuna · extras del marco (18-10-2026)
   - Bolsa (cart drawer de Horizon): barra hacia el envío gratis ($3.000), cuotas sin recargo del total
     y link para pagar por transferencia por WhatsApp. Se arma al abrir el cajón y con cada cambio del carrito.
   - Menú lateral: agrega momentos, pagos y WhatsApp (plantilla <template data-mm-drawer-extra> de momuna-avisos).
   Sin librerías. Umbral y número salen de data-attributes del <html> que escribe momuna-base. */
(function () {
  'use strict';
  var d = document, W = window;
  var UMBRAL = +(d.documentElement.getAttribute('data-mm-umbral') || 300000); // centavos
  var CUOTAS = +(d.documentElement.getAttribute('data-mm-cuotas') || 12);
  var WA = d.documentElement.getAttribute('data-mm-wa') || '';

  function plata(c) {
    c = Math.round(c);
    var p = Math.floor(c / 100), dec = c % 100;
    return '$' + String(p).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? ',' + String(dec).padStart(2, '0') : '');
  }

  /* ---- Bolsa ---- */
  var pidiendo = null;
  function cart() {
    if (pidiendo) return pidiendo;
    pidiendo = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).finally(function () { pidiendo = null; });
    return pidiendo;
  }
  function pintarBolsa() {
    var sum = d.querySelector('.cart-drawer__summary');
    if (!sum) return;
    cart().then(function (c) {
      var total = c.total_price, caja = sum.querySelector('.mm-bx');
      if (!c.item_count) { if (caja) caja.remove(); return; }
      if (!caja) { caja = d.createElement('div'); caja.className = 'mm-bx'; sum.insertBefore(caja, sum.firstChild); }
      var falta = Math.max(UMBRAL - total, 0), p = Math.min(total / UMBRAL, 1);
      caja.classList.toggle('is-gratis', falta === 0);
      var items = c.items.map(function (i) { return i.quantity + ' × ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : ''); }).join(', ');
      var msj = '¡Hola Momuna! Quiero pagar por transferencia: ' + items + '. Total ' + plata(total) + '.';
      caja.innerHTML =
        '<p class="mm-bx__texto">' + (falta === 0 ? '<strong>¡Tenés envío gratis!</strong> Pagando con Mercado Pago o por transferencia.' : 'Te faltan <strong>' + plata(falta) + '</strong> para el envío gratis con Mercado Pago.') + '</p>' +
        '<div class="mm-bx__barra" aria-hidden="true"><i style="--p:' + p.toFixed(3) + '"></i></div>' +
        '<p class="mm-bx__cuotas"><span>' + CUOTAS + ' cuotas sin recargo de</span> <b>' + plata(total / CUOTAS) + '</b></p>' +
        (WA ? '<a class="mm-bx__wa" href="https://wa.me/' + WA + '?text=' + encodeURIComponent(msj) + '" target="_blank" rel="noopener">Pagar por transferencia · envío gratis</a>' : '') +
        upsell(c, falta);
    }).catch(function () {});
  }
  /* Sugerencias del cajón: productos que no están en la bolsa; si falta poco para el envío gratis, lo dice. */
  function upsell(c, falta) {
    var tpl = d.querySelector('template[data-mm-upsell]');
    if (!tpl) return '';
    var ids = c.items.map(function (i) { return String(i.product_id); });
    var items = Array.prototype.slice.call(tpl.content.querySelectorAll('.mm-bx__up')).filter(function (li) { return ids.indexOf(li.getAttribute('data-pid')) < 0; }).slice(0, 2);
    if (!items.length) return '';
    var html = items.map(function (li) {
      var pr = +li.getAttribute('data-precio'), nota = falta > 0 ? (pr >= falta ? ' · con esto llegás al envío gratis' : ' · te quedan ' + plata(falta - pr) + ' para el envío gratis') : '';
      return li.outerHTML.replace('</em>', nota + '</em>');
    }).join('');
    return '<p class="mm-bx__up-titulo">Sumale algo</p><ul class="mm-bx__ups">' + html + '</ul>';
  }
  d.addEventListener('shopify:cart:lines-update', function () { setTimeout(pintarBolsa, 400); setTimeout(pintarBolsa, 1500); });
  d.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], .header-actions__cart-icon, a[href="/cart"]')) { setTimeout(pintarBolsa, 250); setTimeout(pintarBolsa, 900); setTimeout(pintarBolsa, 1800); }
  }, true);
  if ('MutationObserver' in W) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var t = ms[i].target;
        if (t.matches && t.matches('cart-drawer-component, cart-drawer-component *') && !t.closest('.mm-bx')) { setTimeout(pintarBolsa, 60); return; }
      }
    }).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /* ---- Agregar rápido (tarjetas, "Llevalo con", upsell del cajón) ---- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mm-rapido]');
    if (!b) return;
    e.preventDefault();
    var id = +b.getAttribute('data-mm-rapido');
    b.disabled = true; var txt = b.textContent; b.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        b.textContent = '✓ En la bolsa';
        try {
          var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true, cancelable: true });
          ev.action = 'add'; ev.context = 'product'; ev.lines = [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }];
          ev.promise = Promise.resolve({ cart: null, detail: { source: 'momuna', didError: false } });
          d.dispatchEvent(ev);
        } catch (er) {}
        setTimeout(pintarBolsa, 500); setTimeout(pintarBolsa, 1500);
        setTimeout(function () { b.disabled = false; b.textContent = txt; }, 2500);
      }).catch(function () { b.disabled = false; b.textContent = 'No se pudo'; });
  });

  /* ---- Menú lateral ---- */
  function extrasMenu() {
    var tpl = d.querySelector('template[data-mm-drawer-extra]');
    if (!tpl) return;
    var zona = d.querySelector('.header__drawer .menu-drawer');
    if (!zona || zona.querySelector('.mm-dx')) return;
    var lista = zona.querySelector('nav.menu-drawer__navigation');
    var nodo = tpl.content.cloneNode(true);
    if (lista && lista.parentNode) lista.parentNode.insertBefore(nodo, lista.nextSibling); else zona.appendChild(nodo);
  }
  function iniciar() { extrasMenu(); pintarBolsa(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.header__drawer')) setTimeout(extrasMenu, 150); }, true);
})();
